import { createStore, createEffect, createEvent, combine } from 'effector';
import i18n from 'i18n';
import { RegistrationApi, type SignupRequest, type SignupResponse } from '@shared/api';

const signupEffect = createEffect((request: SignupRequest) => RegistrationApi.signup(request));
const clearEvent = createEvent();

const $dataStore = createStore<SignupResponse | null>(null)
  .on(signupEffect.done, (_, data) => data.result.data ?? null)
  .reset(clearEvent);

const $loadingStore = createStore<boolean>(false)
  .on(signupEffect.pending, (_, data) => data)
  .on(signupEffect.fail, () => false)
  .on(signupEffect.done, () => false)
  .reset(clearEvent);

const $errorStore = createStore<string | null>(null)
  .on(signupEffect, () => null)
  .on(signupEffect.fail, (_, data) => i18n.t(`errors.api.${data.error.message}`, data.error.message))
  .on(signupEffect.done, () => null)
  .reset(clearEvent);

export const $signupStore = {
  events: {
    signup: signupEffect,
    clear: clearEvent,
  },
  store: combine({
    loading: $loadingStore,
    data: $dataStore,
    error: $errorStore,
  }),
};
